module.exports = __webpack_public_path__ + "static/media/icon_businessKo.762e9aa1.svg";